import React, { ImgHTMLAttributes } from 'react';
import styled from 'styled-components';

import logo from '../../images/catapult-logo.svg';
import { filterI18nProps } from '../../utils/styledComponentsUtils';

const Image = styled.img<IProps>`
  height: 100%;
  width: auto;
`;

interface IProps extends ImgHTMLAttributes<HTMLImageElement> {
  width?: string
}

const CatapultLogo: React.FC<IProps> = (props: IProps) => (
  <Image {...filterI18nProps(props)} src={logo} />
);

export default CatapultLogo;
